module.exports = __webpack_public_path__ + "img/docx.76bc7d4e.png";